import { RelatedsCarousels, RelatedsStyleVariation } from '../../domain/models/related-products.models';
import { RelatedProductsCarousel } from '../../infrastructure/state/related-products.state';

const relatedPlaceToRelatedProductsCarousel = (
    relatedsCarousels: RelatedsCarousels
): Record<string, Partial<RelatedProductsCarousel>> => {
    return relatedsCarousels.relatedProduct.reduce((acc, carousel, index) => {
        const id = `relateds_${index}`;
        acc[id] = {
            id,
            titleKey: carousel.title_key,
            // Fallback para retrocompatibilidad con la configuración actual de PRO
            view: carousel?.view || RelatedsStyleVariation.carrusel,
            relatedTypes: carousel.items.map((item: any) => {
                return {
                    name: item?.type,
                    maxItems: item?.max,
                    campaign: item?.campaign,
                    excluded: item.excluded,
                };
            }),
            imageType: relatedsCarousels.imageType,
        } as RelatedProductsCarousel;
        return acc;
    }, {});
};

export const relatedProductsTransformers = {
    relatedPlaceToRelatedProductsCarousel,
};
